import React, { useEffect } from 'react';
import classes from './Home12Download.module.scss';
import { Link } from 'react-router-dom';
import Home12Header from './Home12Header';
import Home12LeadForm from './Home12LeadForm';

const Home12Download = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className={classes.root}>
            <Home12Header mode="fixed" />

            <main className={classes.mainContent}>
                <div className={classes.container}>
                    <Home12LeadForm mode="download" classes={classes} />

                    <div className={classes.infoWrapper}>
                        <div className={classes.documentPreview}>
                            <img src="/react-assets/home10/home10-hero-bg-portrait.jpg" alt="資料のプレビュー" className={classes.previewImage} />
                            <div className={classes.previewOverlay}>
                                <h3>collabo nexus<br />サービス紹介資料</h3>
                                <ul>
                                    <li>- 製品の特長と導入メリット</li>
                                    <li>- 主要機能の画面イメージ</li>
                                    <li>- 料金プラン・導入フロー</li>
                                    <li>- 導入事例のご紹介</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            <footer className={classes.footer}>
                <div className={classes.footerLinks}>
                    <Link to="/privacy">プライバシーポリシー</Link>
                </div>
                <div className={classes.companyInfo}>
                    <p>&copy; {new Date().getFullYear()} collabo Inc.</p>
                </div>
            </footer>
        </div>
    );
};

export default Home12Download;
